export default "__VITE_ASSET__BZTibJn2__"